import { render, staticRenderFns } from "./ContinuationTips.vue?vue&type=template&id=9cdba5ee&scoped=true&"
import script from "./ContinuationTips.vue?vue&type=script&lang=js&"
export * from "./ContinuationTips.vue?vue&type=script&lang=js&"
import style0 from "./ContinuationTips.vue?vue&type=style&index=0&id=9cdba5ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdba5ee",
  null
  
)

export default component.exports